import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard,
  Users,
  Package,
  BookOpen,
  CreditCard,
  Subscript,
  MapPin,
  BarChart3,
  AlertTriangle,
  Bell,
  Settings,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Truck
} from 'lucide-react';
import '../../../assets/styles/distributor/DistributorSidebar.css';

const DistributorSidebar = ({ isCollapsed, toggleSidebar }) => {
  const navigate = useNavigate();
  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: LayoutDashboard,
      path: '/distributor/dashboard',
      color: '#4caf50'
    },
    {
      id: 'customers',
      label: 'My Customers',
      icon: Users,
      path: '/distributor/customers',
      color: '#6b7280'
    },
    // {
    //   id: 'suppliers',
    //   label: 'My Suppliers',
    //   icon: Package,
    //   path: '/distributor/suppliers',
    //   color: '#6b7280'
    // },
    {
      id: 'milk-diary',
      label: 'Milk Diary',
      icon: BookOpen,
      path: '/distributor/milk-diary',
      color: '#6b7280'
    },
    {
      id: 'payments',
      label: 'Payments',
      icon: CreditCard,
      path: '/distributor/payments',
      color: '#6b7280'
    },
    {
      id: 'subscription',
      label: 'Subscription',
      icon: Subscript,
      path: '/distributor/subscription',
      color: '#6b7280'
    },
    {
      id: 'area-management',
      label: 'Area Management',
      icon: MapPin,
      path: '/distributor/area-management',
      color: '#6b7280'
    },
    // {
    //   id: 'analytics',
    //   label: 'Analytics',
    //   icon: BarChart3,
    //   path: '/distributor/analytics',
    //   color: '#6b7280'
    // },
    {
      id: 'disputes',
      label: 'Disputes & Support',
      icon: AlertTriangle,
      path: '/distributor/disputes',
      color: '#6b7280'
    },
    {
      id: 'notifications',
      label: 'Notifications',
      icon: Bell,
      path: '/distributor/notifications',
      color: '#6b7280'
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: Settings,
      path: '/distributor/settings',
      color: '#6b7280'
    }
  ];

  const distributorSignOut = () => {
    localStorage.removeItem("distributorPhone");
    localStorage.removeItem("distributorPassword");
    navigate("/distributor-login");
  }

  return (
    <div className={`distributorsidebar-wrapper ${isCollapsed ? 'distributorsidebar-collapsed' : ''}`}>
      {/* Sidebar Header */}
      <div className="distributorsidebar-header">
        <div className="distributorsidebar-logo">
          <div className="distributorsidebar-logo-icon">
            <Truck size={24} strokeWidth={2} />
          </div>
          {!isCollapsed && (
            <div className="distributorsidebar-logo-text">
              <span className="distributorsidebar-logo-title">Distributor</span>
            </div>
          )}
        </div>
      </div>

      {/* Menu Items */}
      <nav className="distributorsidebar-menu">
        <ul className="distributorsidebar-menu-list">
          {menuItems.map((item, index) => (
            <li 
              key={item.id} 
              className="distributorsidebar-menu-item"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `distributorsidebar-menu-link ${isActive ? 'distributorsidebar-menu-link-active' : ''}`
                }
                title={isCollapsed ? item.label : ''}
              >
                <item.icon 
                  className="distributorsidebar-menu-icon" 
                  size={20} 
                  strokeWidth={2}
                />
                {!isCollapsed && (
                  <span className="distributorsidebar-menu-label">{item.label}</span>
                )}
                {!isCollapsed && (
                  <span className="distributorsidebar-menu-indicator"></span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Sidebar Footer */}
      <div className="distributorsidebar-footer">
        {/* Sign Out */}
        <button className="distributorsidebar-signout-btn">
          <LogOut 
            className="distributorsidebar-signout-icon" 
            size={20} 
            strokeWidth={2}
          />
          {!isCollapsed && (
            <span className="distributorsidebar-signout-text" onClick={distributorSignOut}>Sign Out</span>
          )}
        </button>

        {/* Collapse Button */}
        <button 
          className="distributorsidebar-collapse-btn"
          onClick={toggleSidebar}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? (
            <ChevronRight size={20} strokeWidth={2} />
          ) : (
            <>
              <ChevronLeft size={20} strokeWidth={2} />
              <span>Collapse</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default DistributorSidebar;